// source: v2/types/provisioning.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
goog.exportSymbol('proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.DeprovisioningUpdateType', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse', null, global);
goog.exportSymbol('proto.loopup.ctgateway.v2.ProvisioningUpdateType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.displayName = 'proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.displayName = 'proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.displayName = 'proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.displayName = 'proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.displayName = 'proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ddi: jspb.Message.getFieldWithDefault(msg, 3, ""),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse;
  return proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDdi(value);
      break;
    case 4:
      var value = /** @type {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDdi();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ddi = 3;
 * @return {string}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.getDdi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.setDdi = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ProvisioningUpdateType status = 4;
 * @return {!proto.loopup.ctgateway.v2.ProvisioningUpdateType}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.getStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithSpecificDdiUpdateResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ddi: (f = msg.getDdi()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse;
  return proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDdi(value);
      break;
    case 4:
      var value = /** @type {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDdi();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string site_id = 2;
 * @return {string}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.StringValue ddi = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.getDdi = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.setDdi = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.clearDdi = function() {
  return this.setDdi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.hasDdi = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ProvisioningUpdateType status = 4;
 * @return {!proto.loopup.ctgateway.v2.ProvisioningUpdateType}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.getStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.ProvisionServiceUserWithRandomDdiUpdateResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ddi: (f = msg.getDdi()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    siteId: (f = msg.getSiteId()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse;
  return proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDdi(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSiteId(value);
      break;
    case 4:
      var value = /** @type {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDdi();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSiteId();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue ddi = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.getDdi = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.setDdi = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.clearDdi = function() {
  return this.setDdi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.hasDdi = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue site_id = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.getSiteId = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.setSiteId = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.clearSiteId = function() {
  return this.setSiteId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.hasSiteId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ProvisioningUpdateType status = 4;
 * @return {!proto.loopup.ctgateway.v2.ProvisioningUpdateType}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.getStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.ProvisioningUpdateType} value
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetProvisioningUpdatesUpdateResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ddi: (f = msg.getDdi()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse;
  return proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDdi(value);
      break;
    case 4:
      var value = /** @type {!proto.loopup.ctgateway.v2.DeprovisioningUpdateType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDdi();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue ddi = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.getDdi = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.setDdi = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.clearDdi = function() {
  return this.setDdi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.hasDdi = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DeprovisioningUpdateType status = 4;
 * @return {!proto.loopup.ctgateway.v2.DeprovisioningUpdateType}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.getStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.DeprovisioningUpdateType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.DeprovisioningUpdateType} value
 * @return {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.DeprovisionServiceUserUpdateResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    serviceUserId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ddi: (f = msg.getDdi()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updateTime: (f = msg.getUpdateTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse;
  return proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServiceUserId(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setDdi(value);
      break;
    case 4:
      var value = /** @type {!proto.loopup.ctgateway.v2.DeprovisioningUpdateType} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServiceUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDdi();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getUpdateTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string service_user_id = 1;
 * @return {string}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.getServiceUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.setServiceUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.StringValue ddi = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.getDdi = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.setDdi = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.clearDdi = function() {
  return this.setDdi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.hasDdi = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional DeprovisioningUpdateType status = 4;
 * @return {!proto.loopup.ctgateway.v2.DeprovisioningUpdateType}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.getStatus = function() {
  return /** @type {!proto.loopup.ctgateway.v2.DeprovisioningUpdateType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.loopup.ctgateway.v2.DeprovisioningUpdateType} value
 * @return {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp update_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.getUpdateTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} returns this
*/
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.setUpdateTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse} returns this
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.clearUpdateTime = function() {
  return this.setUpdateTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loopup.ctgateway.v2.GetDeprovisioningUpdatesUpdateResponse.prototype.hasUpdateTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.ProvisioningUpdateType = {
  PROVISIONING_UPDATE_TYPE_INVALID: 0,
  PROVISIONING_UPDATE_TYPE_STARTED: 1,
  PROVISIONING_UPDATE_TYPE_FAILED_NO_TOKEN: 2,
  PROVISIONING_UPDATE_TYPE_FAILED_USER_HAS_DDI: 3,
  PROVISIONING_UPDATE_TYPE_FAILED_USER_NOT_CAPABLE: 4,
  PROVISIONING_UPDATE_TYPE_FAILED_USER_DOESNT_EXIST: 5,
  PROVISIONING_UPDATE_TYPE_FAILED_DDI_DOESNT_EXIST: 6,
  PROVISIONING_UPDATE_TYPE_FAILED_DDI_NOT_AVAILABLE: 7,
  PROVISIONING_UPDATE_TYPE_FAILED_NO_DDI_AVAILABLE: 8,
  PROVISIONING_UPDATE_TYPE_FAILED_NO_CUSTOMER_TENANT: 9,
  PROVISIONING_UPDATE_TYPE_RESERVE_DDI_SUCCEEDED: 10,
  PROVISIONING_UPDATE_TYPE_FAILED_NO_VOICE_ROUTING_POLICY_FOR_DDI: 11,
  PROVISIONING_UPDATE_TYPE_PENDING: 12,
  PROVISIONING_UPDATE_TYPE_FAILED_DDI_INVALID_STATE: 13,
  PROVISIONING_UPDATE_TYPE_SUCCEEDED: 14,
  PROVISIONING_UPDATE_TYPE_FAILED_FINAL_STATE_VERIFICATION: 15,
  PROVISIONING_UPDATE_TYPE_FAILED_SITE_DOESNT_EXIST: 16,
  PROVISIONING_UPDATE_TYPE_FAILED_UNKNOWN_ERROR: 17
};

/**
 * @enum {number}
 */
proto.loopup.ctgateway.v2.DeprovisioningUpdateType = {
  DEPROVISIONING_UPDATE_TYPE_INVALID: 0,
  DEPROVISIONING_UPDATE_TYPE_STARTED: 1,
  DEPROVISIONING_UPDATE_TYPE_FAILED_DDI_DOESNT_EXIST: 2,
  DEPROVISIONING_UPDATE_TYPE_FAILED_DDI_NOT_ALLOCATED: 3,
  DEPROVISIONING_UPDATE_TYPE_FAILED_SERVICE_USER_MISMATCH: 4,
  DEPROVISIONING_UPDATE_TYPE_FAILED_SERVICE_USER_DOESNT_EXIST: 5,
  DEPROVISIONING_UPDATE_TYPE_FAILED_SERVICE_USER_DOESNT_HAVE_DDI: 6,
  DEPROVISIONING_UPDATE_TYPE_FAILED_NO_TOKEN: 7,
  DEPROVISIONING_UPDATE_TYPE_SUCCEEDED: 8,
  DEPROVISIONING_UPDATE_TYPE_PENDING: 9,
  DEPROVISIONING_UPDATE_TYPE_REMOVE_DDI_SUCCEEDED: 10,
  DEPROVISIONING_UPDATE_TYPE_FAILED_UNKNOWN_ERROR: 11,
  DEPROVISIONING_UPDATE_TYPE_FAILED_DDI_STATE_INVALID: 12
};

goog.object.extend(exports, proto.loopup.ctgateway.v2);
